<div class="container-modal" tabindex="0">
    <div class="header-container">
        <p class="close"><img src="./assets/logos/close.svg" (click)="closeModal()" alt=""></p>
        <p class="icon-info"><img src="assets/temporals/information-white.svg" alt=""></p>
        <p class="tittle">
            Esta valoración no supone la concesión de un crédito.
            Es una información gratuita y no vinculante que se obtiene mediante un análisis
            objetivo de la información de las cuentas bancarias que has facilitado. <br><br>

            Se han diseñado más de 50 métricas agrupadas en 5 categorías independientes.
            Finalmente cada categoría tiene un peso en el cálculo final de la Salud Financiera. <br><br>

            Para más información visita la sección de <a class="faqs" (click)="goToUrl()" aria-label="Preguntas frecuentes">Preguntas Frecuentes</a>.
        </p>
    </div>
    <br><br>
</div>